<script setup lang="ts">
/**
 * Feature-internal avatar stack (spec §7.1, 168-T3).
 * Приймає pre-computed `preview` від `store.assignedPreview()`.
 * Якщо ростер готовий (initials.length > 0) — показує ≤3 кружки з ініціалами + +N.
 * Якщо ростер не готовий (initials.length === 0) — degrade до count chip.
 * Не DS-примітив, гейт стайлгайду не застосовується (spec §7.5).
 */
defineProps<{
  preview: { initials: string[]; extra: number };
  count: number;
}>();
</script>

<template>
  <span v-if="preview.initials.length > 0" class="avatar-stack" aria-hidden="true">
    <span
      v-for="(init, i) in preview.initials"
      :key="i"
      class="avatar-stack__item"
    >{{ init }}</span>
    <span v-if="preview.extra > 0" class="avatar-stack__overflow">+{{ preview.extra }}</span>
  </span>
  <span v-else class="avatar-stack__count-chip" aria-hidden="true">{{ count }}</span>
</template>

<style scoped>
.avatar-stack {
  display: inline-flex;
  align-items: center;
}

.avatar-stack__item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 2px solid var(--background);
  background-color: var(--accent);
  color: var(--accent-foreground);
  font-size: 0.7rem;
  font-weight: 500;
  margin-inline-start: -0.375rem;
}

.avatar-stack__item:first-child {
  margin-inline-start: 0;
}

.avatar-stack__overflow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 2px solid var(--background);
  background-color: var(--muted);
  color: var(--muted-foreground);
  font-size: 0.7rem;
  margin-inline-start: -0.375rem;
}

.avatar-stack__count-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-inline: 0.5rem;
  height: 1.5rem;
  border-radius: var(--radius);
  background-color: var(--muted);
  color: var(--muted-foreground);
  font-size: 0.75rem;
}
</style>
